import React, { useState, useEffect } from "react";

import {
  ComprovanteRendimentosService,
  DadosPessoaisService,
} from "../../services";

import {
  Row,
  Col,
  Box,
  CampoEstatico,
  TipoCampoEstatico,
  Combo,
  Alerta,
  TipoAlerta,
  Botao,
  TipoBotao,
} from "@intechprev/componentes-web";
import Page from "../Page";
import {
  ComprovanteRendimentosEntidade,
  DadosPessoaisEntidade,
  EntidadePrevidenciaEntidade,
} from "../../entidades";

interface ComboCalendarios {
  name: string;
  valor: string;
}

export const ComprovanteRendimentos: React.FC = (props) => {
  const [loading, setLoading] = useState(false);
  const [AlertText, setAlertText] = useState("");
  const [Dados, setDados] = useState<DadosPessoaisEntidade>(
    new DadosPessoaisEntidade()
  );
  const [Fundacao, setFundacao] = useState<EntidadePrevidenciaEntidade>(
    new EntidadePrevidenciaEntidade()
  );
  const [Calendarios, setCalendarios] = useState<
    Array<ComprovanteRendimentosEntidade>
  >(new Array<ComprovanteRendimentosEntidade>());
  const [ComboCalendarios, setComboCalendarios] = useState<
    Array<ComboCalendarios>
  >(new Array<ComboCalendarios>());
  const [CalendarioSelecionado, setCalendarioSelecionado] = useState<string>(
    ""
  );
  const [Rendimentos, setRendimentos] = useState<
    Array<ComprovanteRendimentosEntidade>
  >(new Array<ComprovanteRendimentosEntidade>());

  useEffect(() => {
    (async () => {
      setLoading(true);

      const calendarios = await ComprovanteRendimentosService.BuscarDatas();
      if (calendarios.length > 0) {
        const dados = await DadosPessoaisService.Buscar();
        const fundacao = await ComprovanteRendimentosService.BuscarFundacao();
        const rendimentos = await ComprovanteRendimentosService.BuscarPorAnoExercicio(
          calendarios[0].ANO_EXERCICIO
        );

        let ComboCalendarios = [];

        for (let i = 0; i < calendarios.length; i++) {
          const c = calendarios[i]; // so pra simplificar
          ComboCalendarios[i] = {
            name: `Ano Exercício ${c.ANO_EXERCICIO} - Ano Calendário ${c.ANO_CALENDARIO}`,
            valor: c.ANO_EXERCICIO,
          };
        }

        setDados(dados);
        setFundacao(fundacao);
        setComboCalendarios(ComboCalendarios);
        setRendimentos(rendimentos);
      }

      setLoading(false);
    })();
  }, []);

  async function baixarDocumento() {
    try {
      setAlertText("");
      const res = await ComprovanteRendimentosService.GerarComprovante(
        Rendimentos[0].SQ_EXERCICIO
      );
      const name = "comprovanteirrf.pdf";
      const UrlResultado = res.UrlResultado;

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([UrlResultado]), name);
      } else {
        const link = document.createElement("a");
        link.href = UrlResultado;
        link.setAttribute("download", name);
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);

        link.click();
      }
    } catch (err) {
      setAlertText(err.response ? err.response.data : err);
    }
  }

  async function SelecionarCalendario(ano: string) {
    setLoading(true);

    const rendimentos = await ComprovanteRendimentosService.BuscarPorAnoExercicio(
      ano
    );
    setCalendarioSelecionado(ano);
    setRendimentos(rendimentos);

    setLoading(false);
  }

  function renderListaRendimentos() {
    return Rendimentos.map(
      (rendimento: ComprovanteRendimentosEntidade, index: number) => {
        const titulo = rendimento.NR_POSICAO_COLUNA === 1;
        const weight = titulo ? "font-weight-bold" : "font-weight-normal";
        const valor = titulo ? "" : rendimento.VL_DECLARACAO;
        if (titulo) {
          return <dt>{rendimento.DS_ITEM_DECLARACAO}</dt>;
        }
        const ValorComplementar =
          rendimento.VL_DECLARACAO === 0 && rendimento.VL_COMPLEMENTAR !== 0 ? (
            <dd className={"d-flex justify-content-around"}>
              <span style={{ flex: 1 }}></span>
              <span style={{ flex: 12 }}>{"rendimento.NO_"}</span>
              <span className={"text-right"} style={{ flex: 2 }}>
                <CampoEstatico
                  valor={rendimento.VL_COMPLEMENTAR}
                  tipo={TipoCampoEstatico.dinheiro}
                />
              </span>
            </dd>
          ) : null;
        return (
          <dd className={"d-flex justify-content-around"}>
            <span style={{ flex: 1 }}></span>
            <span style={{ flex: 12 }}>{rendimento.DS_ITEM_DECLARACAO}</span>
            <span className={"text-right"} style={{ flex: 2 }}>
              <CampoEstatico
                valor={rendimento.VL_DECLARACAO}
                tipo={TipoCampoEstatico.dinheiro}
              />
            </span>
          </dd>
        );
        // return (
        //     <Row className={weight + " justify-content-between"} key={index}>
        //         {/* <Col>{rendimento.DS_ITEM_DECLARACAO}</Col> */}
        //         {/* <Col>
        //             <CampoEstatico
        //             title={rendimento.DS_ITEM_DECLARACAO}
        //                 valor={valor}
        //                 labelSize={8}
        //                 tipo={TipoCampoEstatico.dinheiro}

        //             />
        //         </Col> */}
        //         <Col>{rendimento.DS_ITEM_DECLARACAO}</Col>
        //         <span>{valor}</span>
        //     </Row>
        // );
      }
    );
  }

  function FixCGC(NR_CGC: string | undefined) {
    if (NR_CGC === undefined) {
      return "";
    }
    return `${NR_CGC.substring(0, 2)}.${NR_CGC.substring(
      2,
      5
    )}.${NR_CGC.substring(5, 8)}/${NR_CGC.substring(8, 12)}-${NR_CGC.substring(
      12,
      14
    )}`;
  }

  function renderComRendimentos(this: any) {
    if (Rendimentos.length > 0) {
      return (
        <>
          <Combo
            contexto={this}
            nome={"CalendarioSelecionado"}
            titulo={"Período"}
            valor={CalendarioSelecionado}
            opcoes={ComboCalendarios}
            nomeMembro={"name"}
            valorMembro={"valor"}
            onChange={async (e: any) => await SelecionarCalendario(e)}
          />

          <br />

          <dl>
            <dt>{"1. FONTE PAGADORA PESSOA JURÍDICA OU PESSOA FÍSICA"}</dt>
            <dd className={"d-flex justify-content-around"}>
              <span style={{ flex: 1 }}></span>
              <span style={{ flex: 6 }}>{"CNPJ"}</span>
              <span className={"text-right"} style={{ flex: 8 }}>
                <CampoEstatico valor={FixCGC(Fundacao.NR_CGC)} />
              </span>
            </dd>
            <dd className={"d-flex justify-content-around"}>
              <span style={{ flex: 1 }}></span>
              <span style={{ flex: 6 }}>{"Nome"}</span>
              <span className={"text-right"} style={{ flex: 8 }}>
                <CampoEstatico valor={Fundacao.NO_PESSOA || ""} />
              </span>
            </dd>

            <dt>{"2. PESSOA FÍSICA BENEFICIÁRIA DOS RENDIMENTOS"}</dt>
            <dd className={"d-flex justify-content-around"}>
              <span style={{ flex: 1 }}></span>
              <span style={{ flex: 6 }}>{"CPF"}</span>
              <span className={"text-right"} style={{ flex: 8 }}>
                <CampoEstatico
                  valor={`${Dados.NR_CPF.substring(
                    0,
                    3
                  )}.${Dados.NR_CPF.substring(3, 6)}.${Dados.NR_CPF.substring(
                    6,
                    9
                  )}-${Dados.NR_CPF.substring(9, 11)}`}
                />
              </span>
            </dd>
            <dd className={"d-flex justify-content-around"}>
              <span style={{ flex: 1 }}></span>
              <span style={{ flex: 6 }}>{"Nome"}</span>
              <span className={"text-right"} style={{ flex: 8 }}>
                <CampoEstatico valor={Dados.NO_PESSOA} />
              </span>
            </dd>
            <dd className={"d-flex justify-content-around"}>
              <span style={{ flex: 1 }}></span>
              <span style={{ flex: 6 }}>{"Natureza do Rendimento"}</span>
              <span className={"text-right"} style={{ flex: 8 }}>
                <CampoEstatico valor={Rendimentos[0].DS_RECEITA} />
              </span>
            </dd>

            {renderListaRendimentos()}
          </dl>

          <Alerta tipo={TipoAlerta.info} mensagem={AlertText} />

          <Botao
            titulo={"Gerar Comprovante IRRF"}
            tipo={TipoBotao.primary}
            // loadingText={"Baixando..."}
            usaLoading
            onClick={baixarDocumento}
          />
        </>
      );
    }
    return (
      <Alerta
        tipo={TipoAlerta.info}
        mensagem={"Nenhum comprovante de rendimento disponível para você!"}
      />
    );
  }

  return (
    <Page {...props}>
      <Row>
        <Col>
          <Box>{renderComRendimentos()}</Box>
        </Col>
      </Row>
    </Page>
  );
};
